import { Stack, Typography } from "@mui/material"

export function TaskRowHeader({ label, status }) {
    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ mb: "14px", pb: "10px", borderBottom: "1px solid #d7dce2" }}
        >
            <Typography sx={{ fontWeight: 700, fontSize: "11px", color: "#1f2937" }}>{label}</Typography>
            <Typography sx={{ fontWeight: 700, fontSize: "10px", color: getStatusColor(status) }}>
                {getStatusLabel(status)}
            </Typography>
        </Stack>
    )

    function getStatusLabel(status) {
        switch (status) {
            case "new":
                return "New Task"
            case "modified":
                return "Modified"
            case "removed":
                return "Removed"
            default:
                return "No Changes"
        }
    }

    function getStatusColor(status) {
        switch (status) {
            case "new":
                return "#299c46"
            case "modified":
                return "#2b95a2"
            case "removed":
                return "#9b2c2c"
            default:
                return "#617184"
        }
    }
}
